const SHOWCASE_ITEMS = [
  {
    video: '/api/prototype-assets/videos/Vid1.mp4',
    prompt: 'A young boy drifting alone through the stars, searching for his way home',
    feature: 'Script & direction',
    featureDesc: 'generated from your prompt',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
      </svg>
    ),
  },
  {
    video: '/api/prototype-assets/videos/Vid2.mp4',
    prompt: 'A brave knight with silver armor standing guard at the castle gates',
    feature: 'Consistent characters',
    featureDesc: 'across every scene',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ),
  },
  {
    video: '/api/prototype-assets/videos/Vid3.mp4',
    prompt: 'A towering mech robot battles kaiju monsters on a chaotic film set, explosions and crew scrambling everywhere',
    feature: 'Cinematic shots',
    featureDesc: 'with professional composition',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/>
        <line x1="7" y1="2" x2="7" y2="22"/>
        <line x1="17" y1="2" x2="17" y2="22"/>
        <line x1="2" y1="12" x2="22" y2="12"/>
        <line x1="2" y1="7" x2="7" y2="7"/>
        <line x1="2" y1="17" x2="7" y2="17"/>
        <line x1="17" y1="17" x2="22" y2="17"/>
        <line x1="17" y1="7" x2="22" y2="7"/>
      </svg>
    ),
  },
  {
    video: '/api/prototype-assets/videos/Vid4.mp4',
    prompt: 'A heartfelt reunion between two old friends after years apart',
    feature: 'Music & sound',
    featureDesc: 'generated to match visuals',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M9 18V5l12-2v13"/>
        <circle cx="6" cy="18" r="3"/>
        <circle cx="18" cy="16" r="3"/>
      </svg>
    ),
  },
]

interface ShowcaseSectionProps {
  onRecreate?: (prompt: string) => void
}

export default function ShowcaseSection({ onRecreate }: ShowcaseSectionProps) {
  return (
    <div className="sticky-scroll-section-inner">
      <div className="sticky-scroll-container">
        <div className="sticky-left">
          <span className="sticky-label">Creation</span>
          <h2 className="sticky-title">From idea to final cut</h2>
          <p className="sticky-desc">
            AI agents handle every stage of production. Focus on the story—go from script to screen in minutes, not months.
          </p>
        </div>
        <div className="scroll-right">
          {SHOWCASE_ITEMS.map((item, index) => (
            <div key={index} className="scroll-item">
              <div className="scroll-item-visual">
                <video 
                  src={item.video} 
                  muted 
                  loop 
                  playsInline 
                  autoPlay
                />
                <div className="scroll-item-overlay">
                  <span className="prompt-label">PROMPT</span>
                  <p className="prompt-text">&ldquo;{item.prompt}&rdquo;</p>
                  <div className="scroll-btn-group">
                    <button 
                      className="scroll-btn-primary"
                      onClick={() => onRecreate?.(item.prompt)}
                    >
                      Recreate
                    </button>
                    <button className="scroll-btn-secondary">Explore</button>
                  </div>
                </div>
              </div>
              <p className="scroll-item-text">
                {item.icon}
                <strong>{item.feature}</strong> {item.featureDesc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
